export default "__VITE_ASSET__Baa85Nto__"